export default __webpack_public_path__ + "static/media/ags_thumb.c1f048b3.jpg";